// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3TMIt","col":"styles_col__3qbtR"};